import { ArrowLeft, MapPin, Mail, Phone, Award, Calendar, GraduationCap } from "lucide-react";

export default function About() {
  return (
    <div className="site" style={{ minHeight: "100dvh" }}>
      <header className="nav">
        <a href="/" className="brand" aria-label="Rasel Mia home">
          <span className="brand-mark">RM</span>
          <span>Md. Rasel Mia</span>
        </a>
        <span aria-hidden="true" />
        <a href="/" className="nav-cta">
          <ArrowLeft size={16} />
          Back home
        </a>
      </header>

      <main style={{ paddingTop: "clamp(16px, 4vw, 32px)" }}>
        <section className="section" style={{ paddingTop: 0 }}>
          <div className="wrap">
            <span className="eyebrow">About</span>
            <h1 className="display" style={{ fontSize: "clamp(2rem, 6vw, 4.8rem)", marginTop: 18, lineHeight: 1.05 }}>
              IT Support Engineer based in Dhaka.
            </h1>
            <div className="about" style={{ marginTop: "clamp(28px, 5vw, 48px)" }}>
              <div>
                <img
                  src="/assets/rasel-photo-34.jpg"
                  alt="Md. Rasel Mia"
                  style={{
                    width: "100%",
                    maxWidth: 380,
                    aspectRatio: "3/4",
                    objectFit: "cover",
                    borderRadius: 24,
                    border: "1px solid var(--line)",
                  }}
                />
              </div>
              <div className="about-body">
                <p>
                  <strong>Hello, I am Md. Rasel Mia.</strong> I have been working in IT support and network operations for several years, helping organisations keep their systems running smoothly with a calm, methodical approach.
                </p>
                <p>
                  My day-to-day work involves desktop support, Windows Server administration, Active Directory management, DNS and hosting configuration, and network troubleshooting with MikroTik and Cisco equipment. I also hold certifications from CompTIA, Cisco, and Microsoft.
                </p>
                <p>
                  I am currently open to new IT support, network support, and technical operations roles in Dhaka.
                </p>

                <div className="hero-meta about-meta" style={{ marginTop: 40 }}>
                  <div>
                    <div className="meta-ico"><MapPin size={18} /></div>
                    <div>
                      <strong>Dhaka, Bangladesh</strong>
                      <span>Location</span>
                    </div>
                  </div>
                  <div>
                    <div className="meta-ico"><Mail size={18} /></div>
                    <div>
                      <strong>md.rasel.mia10010@gmail.com</strong>
                      <span>Email</span>
                    </div>
                  </div>
                  <div>
                    <div className="meta-ico"><Phone size={18} /></div>
                    <div>
                      <strong>+880 1641-108619</strong>
                      <span>Phone</span>
                    </div>
                  </div>
                </div>

                <div style={{ marginTop: 40, display: "grid", gap: 16 }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
                    <div className="meta-ico"><Award size={18} /></div>
                    <div><strong style={{ fontFamily: "Space Grotesk", fontWeight: 500 }}>CompTIA A+</strong></div>
                  </div>
                  <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
                    <div className="meta-ico"><Award size={18} /></div>
                    <div><strong style={{ fontFamily: "Space Grotesk", fontWeight: 500 }}>CCNA</strong></div>
                  </div>
                  <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
                    <div className="meta-ico"><Calendar size={18} /></div>
                    <div><strong style={{ fontFamily: "Space Grotesk", fontWeight: 500 }}>Windows Server 2019 / MCSA</strong></div>
                  </div>
                  <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
                    <div className="meta-ico"><GraduationCap size={18} /></div>
                    <div><strong style={{ fontFamily: "Space Grotesk", fontWeight: 500 }}>MTCNA</strong></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <footer className="foot" style={{ marginTop: "auto" }}>
        <div className="wrap foot-inner">
          <span>&copy; {new Date().getFullYear()} Md. Rasel Mia</span>
          <div className="foot-links">
            <a href="/">Home</a>
            <a href="/assets/Md-Rasel-Mia-CV.pdf" download>Download CV</a>
          </div>
        </div>
      </footer>
    </div>
  );
}
